import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";

const employeeReceivableApi = factory.get("employeeReceivable");

const initialState = {
  receivables: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      employee_id: null,
      item_id: null,
      department_id: null,
    },
    dialog: false,
  },
};

export const employeeReceivableSlice = createSlice({
  name: "employeeReceivable",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.receivables.loading = !state.receivables.loading;
    },
    setData: (state, action) => {
      state.receivables.data = action.payload.data.data;
      state.receivables.total = action.payload.data.total;
    },
    setFilters: (state, { payload }) => {
      state.receivables.filters = {
        ...state.receivables.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.receivables.filters = initialState.receivables.filters;
    },
    setFiltersDialog: (state) => {
      state.receivables.dialog = !state.receivables.dialog;
    },
  },
});

export const {
  setLoading,
  setData,
  setFilters,
  resetFilters,
  setFiltersDialog,
} = employeeReceivableSlice.actions;

export default employeeReceivableSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().employeeReceivable.receivables.filters;
    dispatch(setLoading());
    const res = await employeeReceivableApi.index({
      employee_id: filters.employee_id?.id,
      item_id: filters.item_id?.id,
      department_id: filters.department_id?.id,
    });
    dispatch(setData(res));
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.errors?.[0] || "Failed to fetch data",
      })
    );
    throw new Error(err);
  }
};

export const EmployeeReceivable = {
  index,
};
